import { Component, h, render } from "preact";
import {
  INJECT_WRAPPER_ELEMENT,
  PRODUCT_ELEMENT,
  PRODUCT_UID_ATTR,
} from "@/constants/selectors";

import $ from "jquery";
import ReviewForm from "@/components/ReviewForm/ReviewForm";
import ReviewsList from "@/components/ReviewsList/ReviewsList";
import Stars from "@/components/ProductRating/ProductRating";
import { scrollToReviews } from "./scrollToReviews";

/**
 * @param {*} modalJqElement
 * @param {*} logger
 */
export function injectInModal(modalJqElement, logger) {
  const productUid = $(modalJqElement)
    .find(PRODUCT_ELEMENT)
    .attr(PRODUCT_UID_ATTR);

  if (!productUid) return;

  logger.info("injectInModal starts", { productUid, modalJqElement });

  const reviewsListElement = $(INJECT_WRAPPER_ELEMENT);
  render(<ReviewsList productUid={productUid} />, reviewsListElement.get(0));

  const reviewFormElement = $(INJECT_WRAPPER_ELEMENT);
  render(<ReviewForm productUid={productUid} />, reviewFormElement.get(0));

  const starsMiniElModalElement = $(INJECT_WRAPPER_ELEMENT);
  render(
    <Stars
      productUid={productUid}
      onClick={() => scrollToReviews(productUid, modalJqElement[0])}
    />,
    starsMiniElModalElement.get(0)
  );

  modalJqElement
    .find(".t-store__prod-popup__container")
    .append([reviewsListElement, reviewFormElement]);
  modalJqElement
    .find(".t-store__prod-popup__name")
    .before(starsMiniElModalElement);

  logger.info("injectInModal finish");
}
